import { render, staticRenderFns } from "./WhiteBox.vue?vue&type=template&id=4ef51420&scoped=true&"
import script from "./WhiteBox.vue?vue&type=script&lang=ts&"
export * from "./WhiteBox.vue?vue&type=script&lang=ts&"
import style0 from "./WhiteBox.vue?vue&type=style&index=0&id=4ef51420&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ef51420",
  null
  
)

export default component.exports